import { memo } from 'react';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { FilterButton } from 'common/FilterButton/FilterButton';
import type { OrganizationsTableControlsProps } from './types';
import styles from './Controls.module.scss';

export const OrganizationsTableControls = memo<OrganizationsTableControlsProps>((props) => {
  return (
    <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
      <FilterButton count={props.filterCount} click={props.showSider} />
      <TableColumnsFilter
        visibleKeys={props.visibleKeys}
        columns={props.columns}
        setVisibleKeys={props.setVisibleKeys}
      />
    </AppFlex>
  );
});
